<template>
  <article class="detail-inner-item" :class="{ 'high-priority': data.star === 'high' }">
    <div class="title">
      <a-icon
        v-if="data.star === 'high'"
        type="star"
        theme="filled"
        class="priority-icon"
      />
      <span class="name">{{ data.itemNo }}、{{ data.itemName }}</span>
      <span
        v-if="isPrint || [Links.Rectification, Links.Examine, Links.End].includes(link)"
        class="status"
        :style="isPrint && formData.status === 2 ? 'color: #f56c6c;' : (isPrint ? 'color: #52c41a;' : '')"
        >（{{
          ItemStatusText[formData.status] || "符合"
        }}）</span
      >
      <span v-if="formData.isZG" :style="isPrint ? 'color: #67c23a;' : ''">已整改</span>
    </div>
    <div class="options" v-if="[Links.Check, Links.Plan].includes(link)">
      <a-radio-group v-model="formData.status" :options="options" />
      <!-- <a-checkbox v-if="value === '不符合'" :checked.sync="formState.isproblem"
        >重大问题</a-checkbox
      > -->
    </div>
    <div v-if="formData.status === ItemStatus['不符合']" class="form">
      <a-form
        :model="formData"
        name="basic"
        autocomplete="off"
        :layout="'vertical'"
        ref="formRef"
      >
        <a-form-item
          label="不符合原因"
          name="content"
          :rules="[{ required: true, message: '请输入不符合原因!' }]"
        >
          <div class="flexwapper">
            <div v-if="isPrint" class="print-text-content">{{ formData.content }}</div>
            <a-textarea
              v-else
              class="textarea"
              placeholder="可输入500字以内的检查备注"
              :autoSize="{ minRows: 4, maxRows: 6 }"
              :disabled="
                [Links.Rectification, Links.Examine, Links.End].includes(link)
              "
              v-model="formData.content"
            />
            <Upload
              v-if="
                !isPrint && ![Links.Rectification, Links.Examine, Links.End].includes(link)
              "
              class="upload"
              :ID_image="fileList"
              :count="3"
              @handleChange="handleFileChange"
            />
            <div class="imgbox" v-else-if="formData.img && (Array.isArray(formData.img) ? formData.img.length : formData.img)">
              <template v-for="(imgUrl, idx) in (Array.isArray(formData.img) ? formData.img : [formData.img])">
                <img v-if="isImage(imgUrl)" :key="'img-'+idx" :src="imgUrl" />
                <a v-else :key="'file-'+idx" :href="imgUrl" target="_blank" class="file-card-link">
                  <span class="file-ext-badge">{{ getFileExt(imgUrl) }}</span>
                  <span class="file-card-name">{{ getFileName(imgUrl) }}</span>
                </a>
              </template>
            </div>
          </div>
        </a-form-item>
        <section class="rows">
          <a-form-item label="整改期限" name="date" :rules="[{ required: true, message: '请选择整改期限!' }]">
            <a-space>
              <span v-if="isPrint">{{ formatPrintDate(formData.date, 'YYYY-MM-DD') }}</span>
              <a-date-picker
                v-else
                v-model="formData.date"
                format="YYYY-MM-DD"
                @change="changeTime"
                :disabled="
                  [Links.Rectification, Links.Examine, Links.End].includes(link)
                "
              />
              <div
                v-if="
                  isPrint || [Links.Rectification, Links.Examine, Links.End].includes(link)
                "
              >
                {{ formData.immediate ? "立即整改" : "" }}
              </div>
              <a-checkbox
                v-else
                v-model="formData.immediate"
                @change="changeImmediate"
                >立即整改</a-checkbox
              >
            </a-space>
          </a-form-item>
          <a-form-item
            v-if="
              [Links.Rectification, Links.Examine, Links.End].includes(link)
            "
            label="整改时间"
            name="changeDate"
            labelAlign="left"
            :rules="[{ required: true, message: '请选择整改时间！' }]"
          >
            <span v-if="isPrint">{{ formatPrintDate(formData.changeDate, 'YYYY-MM-DD HH:mm:ss') }}</span>
            <a-date-picker
              v-else
              :disabled="formData.isZG"
              show-time
              placeholder="请选择"
              v-model="formData.changeDate"
              format="YYYY-MM-DD HH:mm:ss"
            />
          </a-form-item>
        </section>
        <!--   <a-form-item name="remember" :wrapper-col="{ offset: 8, span: 16 }">
          <a-checkbox :checked.sync="formState.remember">Remember me</a-checkbox>
        </a-form-item> -->
        <section class="rows" :class="{ 'print-rows': isPrint }">
          <a-form-item label="产生原因" name="cause" :rules="[{ required: true, message: '请输入产生原因!' }]">
            <div v-if="isPrint" class="print-text-content">{{ formData.cause }}</div>
            <a-textarea
              v-else
              :disabled="formData.isZG"
              class="textarea"
              placeholder="不符合项目产生原因"
              :autoSize="{ minRows: 4, maxRows: 6 }"
              v-model="formData.cause"
            />
          </a-form-item>
          <a-form-item label="针对不符合项目的防范措施" name="measure" :rules="[{ required: true, message: '请输入防范措施!' }]">
            <div v-if="isPrint" class="print-text-content">{{ formData.measure }}</div>
            <a-textarea
              v-else
              :disabled="formData.isZG"
              class="textarea"
              placeholder="可输入200字以内"
              :autoSize="{ minRows: 4, maxRows: 6 }"
              v-model="formData.measure"
            />
          </a-form-item>
        </section>
          <a-form-item
            label="解决方法"
            name="method"
            :rules="[{ required: true, message: '请输入解决方法!' }]"
          >
            <div class="flexwapper">
              <div v-if="isPrint" class="print-text-content">{{ formData.method }}</div>
              <a-textarea
                v-else
                :disabled="formData.isZG"
                class="textarea"
                placeholder="可输入200字以内"
                :autoSize="{ minRows: 4, maxRows: 6 }"
                v-model="formData.method"
              />
              <Upload
                v-if="!isPrint && !formData.isZG"
                class="upload"
                :ID_image="fileList2"
                :count="3"
                @handleChange="handleFileChange2"
              />
              <div class="imgbox" v-else-if="formData.methodImg && (Array.isArray(formData.methodImg) ? formData.methodImg.length : formData.methodImg)">
                <template v-for="(imgUrl, idx) in (Array.isArray(formData.methodImg) ? formData.methodImg : [formData.methodImg])">
                  <img v-if="isImage(imgUrl)" :key="'mimg-'+idx" :src="imgUrl" />
                  <a v-else :key="'mfile-'+idx" :href="imgUrl" target="_blank" class="file-card-link">
                    <span class="file-ext-badge">{{ getFileExt(imgUrl) }}</span>
                    <span class="file-card-name">{{ getFileName(imgUrl) }}</span>
                  </a>
                </template>
              </div>
            </div>
          </a-form-item>

          <div style="display: flex; justify-content: flex-end; align-items: center; margin-right: 20px; margin-bottom: 10px;">
            <span v-if="!isFormValid && !formData.isZG && link === Links.Rectification" style="color: #ff4d4f; margin-right: 10px; font-size: 13px;">{{ missingFieldsText }}</span>
            <a-button
              v-if="!formData.isZG && link === Links.Rectification"
              :disabled="!isFormValid"
              type="primary"
              @click="submit"
              >提交整改项</a-button
            >
          </div>
        <!-- <template v-if="[Links.End].includes(link)">
          <section class="rows">
            <a-form-item label="审核结果" name="cause">
              <a-input
                disabled
                placeholder="整改完成"
                v-model="formData.cause"
              />
            </a-form-item>
            <a-form-item label="审核时间" name="time">
              <a-date-picker
                disabled
                show-time
                placeholder="请选择"
                :format="'YYYY-MM-DD HH:mm:ss'"
              />
            </a-form-item>
          </section>
          <a-form-item label="审核意见" name="cause">
            <a-input
              disabled
              placeholder="请输入审核意见"
              v-model="formData.cause"
            />
          </a-form-item>
        </template> -->
      </a-form>
      <a-modal v-model="previewVisible" :footer="null" @cancel="handleCancel">
        <img alt="example" style="width: 100%" :src="previewImage" />
      </a-modal>
    </div>
  </article>
</template>
<script setup>
import { ref, computed } from "vue";
import methods from "./methods";
import { Links, ItemStatus, ItemStatusText } from "../../data/template";
import moment from "moment";
import Upload from "@/components/Upload/index";

const props = defineProps({
  data: {
    type: Object,
    default: () => ({}),
  },
  isPrint: {
    type: Boolean,
    default: false,
  },
});

const formatPrintDate = (date, format = 'YYYY-MM-DD') => {
  if (!date) return '';
  if (typeof date === 'string') {
    const m = moment(date);
    if (m.isValid()) {
      return m.format(format);
    }
    return date;
  }
  if (date && typeof date.format === 'function') {
    return date.format(format);
  }
  return date;
};

const isImage = (url) => /\.(png|jpe?g|gif|webp|bmp|svg)(\?.*)?$/i.test(url);
const getFileName = (url) => {
  if (!url) return '附件';
  const parts = url.split('/');
  return decodeURIComponent(parts[parts.length - 1].split('?')[0]) || '附件';
};
const getFileExt = (url) => {
  if (!url) return 'FILE';
  const m = url.toLowerCase().match(/\.([^.?]+)(\?|$)/);
  return m ? m[1].toUpperCase() : 'FILE';
};

const {
  uploadUrl,
  uploadHeaders,
  link,
  id,
  changeTime,
  changeImmediate,
  formData,
  fileList,
  fileList2,
  previewVisible,
  previewImage,
  handleCancel,
  handlePreview,
  options,
  handleChange,
  handleChange2,
  handleFileChange,
  handleFileChange2,
  submit,
} = methods(props);

const isFormValid = computed(() => {
  // 检查所有必填项
  const hasContent = !!formData.value.content;
  const hasDate = !!formData.value.date;
  const hasCause = !!formData.value.cause;
  const hasMeasure = !!formData.value.measure;
  const hasMethod = !!formData.value.method;
  
  // 整改时间仅在特定环节必填
  let hasChangeDate = true;
  if ([Links.Rectification, Links.Examine, Links.End].includes(link.value)) {
    hasChangeDate = !!formData.value.changeDate;
  }
  
  return hasContent && hasDate && hasCause && hasMeasure && hasMethod && hasChangeDate;
});

const missingFieldsText = computed(() => {
  const missing = [];
  if (!formData.value.content) missing.push("不符合原因");
  if (!formData.value.date) missing.push("整改期限");
  if ([Links.Rectification, Links.Examine, Links.End].includes(link.value) && !formData.value.changeDate) missing.push("整改时间");
  if (!formData.value.cause) missing.push("产生原因");
  if (!formData.value.measure) missing.push("防范措施");
  if (!formData.value.method) missing.push("解决方法");
  
  if (missing.length === 0) return "";
  return "请填写: " + missing.join("、");
});
</script>
<style lang="less" scoped>
.detail-inner-item {
  line-height: 30px;
  border-bottom: 1px dashed #dcdcdc;
  margin-bottom: 15px;
  padding-bottom: 10px;
  cursor: pointer;
  padding-left: 20px;
  position: relative;
}
.title {
  .name {
    font-size: 16px;
  }
}
.flexwapper {
  display: flex;
  align-items: center;
  gap: 20px;
  .textarea {
    width: 70%;
  }
  .upload {
    flex: 1;
  }
}
.item-row {
  flex-direction: row;
  align-items: center;
  gap: 10px;
}
.rows {
  display: flex;
  width: 100%;
  gap: 20px;
  > * {
    flex: 1;
  }
}
.status {
  color: rgb(64, 158, 255);
}
.ant-form-item {
  margin-bottom: 12px;
}
.imgbox{
  height: 100px;
  max-width: 200px;
  img{
    height: 100%;
    width: 100%;
    object-fit: contain;
  }
}

/* 高优先级样式 */
.high-priority {
  background: linear-gradient(90deg, #fff5f5 0%, #ffffff 100%);
  border-left: 3px solid #ff4d4f;
  font-weight: 500;
  
  .title .name {
    font-weight: 500;
  }
}

.priority-icon {
  color: #ff4d4f;
  font-size: 14px;
  margin-right: 4px;
}

.print-text-content {
  white-space: pre-wrap;
  word-wrap: break-word;
  line-height: 1.5;
  padding: 4px 0;
  width: 100%;
}

.print-rows {
  display: block !important;

  .ant-form-item {
    margin-bottom: 10px;
    width: 100%;
  }
}

.file-card-link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  background: #fafafa;
  text-decoration: none;
  color: #333;
  max-width: 240px;

  &:hover {
    border-color: #40a9ff;
    color: #40a9ff;
  }

  .file-ext-badge {
    display: inline-block;
    padding: 1px 5px;
    border-radius: 3px;
    background: #fa8c16;
    color: #fff;
    font-size: 10px;
    line-height: 16px;
    flex-shrink: 0;
  }

  .file-card-name {
    font-size: 12px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
